import { render, staticRenderFns } from "./ConfirmBox.vue?vue&type=template&id=05b916b0&scoped=true"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBox.vue?vue&type=style&index=0&id=05b916b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b916b0",
  null
  
)

export default component.exports